<template>
  <div class="bg-white mt-4 shadow overflow-hidden rounded-lg p-5">
    <slot />
  </div>
</template>
